import { createRequest, RequestConfig } from 'app/common/api';

import { TEmployee } from '../core/employee';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_employee',
};

type NewEmployee = Omit<TEmployee, 'id'>;

export const addEmployeeRequest = (body: NewEmployee) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
